export enum CitiesDataTestidEnum {
  CITY_MOCK_BRANCH_LIST_ITEM = 'city--mock-branch-list-item',
  CITY_BRANCH_LIST_SHOW_MORE_BRANCHES = 'city-branch-list--show-more-branches',
  CITY_BRANCH_PROFILE_HEADER = 'city-branch-profile--header',
  CITY_BRANCH_PROFILE_ADDRESS = 'city-branch-profile--address',
  CITY_BRANCH_PROFILE_CONTACT = 'city-branch-profile--contact',
  CITY_BRANCH_PROFILE_ASIDE_CARD = 'city-branch-profile--aside-card',
}
